const SET_MILK_ANALYSIS = (state, payload) => {
  state.results = payload;
}

export default {
  SET_MILK_ANALYSIS
}